import React from 'react'
import Layout from '../components/Layout'
import iconSet from "../fonts/selection.json";
import IcomoonReact from "icomoon-react";
function Contact() {
    return (
        <Layout>
            <section className='contactSec'>
                <h3>LOCATION</h3>
                <h2>CONTACT ME</h2>

                <div className='basicInfo'>
                    <div className='col-12 col-xl-6 col-md-12 px-3 mb-2'>
                        <div className='basicList'>
                            <ul>
                                <li>
                                <IcomoonReact iconSet={iconSet} color="#99be77" size={18} icon="arrow-right2" style={{ marginRight: 10 }} />
                                    <strong>PHONE   : </strong>
                                    +92 302 9050 360
                                </li>

                                <li>
                                <IcomoonReact iconSet={iconSet} color="#99be77" size={18} icon="arrow-right2" style={{ marginRight: 10 }} />
                                    <strong>EMAIL   : </strong>
                                    mirzairtiza15@gmail.com
                                </li>
                                
                                <li>
                                <IcomoonReact iconSet={iconSet} color="#99be77" size={18} icon="arrow-right2" style={{ marginRight: 10 }} />
                                    <strong>LINKEDIN    : </strong>
                                    /mirza-irtiza-wahid
                                </li>
                            </ul>
                        </div>
                    </div>
                    {/* <div className='col-12 col-xl-6 col-md-12 px-3 mb-2'>
                        <form className='contactForm'>
                            <input 
                                placeholder='Your Name *'
                            />
                            <input 
                                placeholder='Your Email *'
                            />
                            <textarea placeholder='Your Message *'>

                            </textarea>
                            <button className='btn'>Submit</button>
                        </form>
                    </div> */}
                </div>
            </section>
        </Layout>
    )
}

export default Contact